import { getCircleStyles } from './variantStyles/circle';
import { getCircleImageStyles } from './variantStyles/circleImage';
import { getCircleImageWithoutBorderStyles } from './variantStyles/circleImageWithoutBorder';
import { getCircleWithoutBorderStyles } from './variantStyles/circleWithoutBorder';
import { getSquareStyles } from './variantStyles/square';
import { getSquareImageStyles } from './variantStyles/squareImage';
export const getIconHighlightedStyles = (FOUNDATIONS, FONT) => {
    return {
        ...getCircleStyles(FOUNDATIONS, FONT),
        ...getSquareStyles(FOUNDATIONS, FONT),
        ...getCircleImageStyles(FOUNDATIONS, FONT),
        ...getSquareImageStyles(FOUNDATIONS, FONT),
        ...getCircleWithoutBorderStyles(FOUNDATIONS, FONT),
        ...getCircleImageWithoutBorderStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map